
export default function applyPackagesCache({ proj, paths, manifest, version, scriptsDomainUrl }) {
  const validForCache = pkg => paths[pkg] && manifest[pkg] !== version
  const overrideFromCache = pkg => {
    paths[pkg] = `${scriptsDomainUrl}services/${proj}/${manifest[pkg]}/${paths[pkg]}`
  }

  Object.keys(manifest).filter(validForCache).forEach(overrideFromCache)
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/common/applyPackagesCache.js